// employee/reducers.ts
const initialState = {
    getAllotmentData: [],
    getAllotmentCount: null,
    createAllotmentData: null,
    updateAllotmentData: null,
    getAllotmentMetaMessage: null,
    getAllotmentSuccess: false,
    getAllotmentFailure: false,
    createAllotmentSuccess: false,
    createAllotmentFailure: false,
    updateAllotmentSuccess: false,
    updateAllotmentFailure: false,
    deleteAllotmentSuccess: false,
    deleteAllotmentFailure: false,
};

export default function AllotmentReducer(state = initialState, action: any) {
    switch (action.type) {
        case 'GET_ALLOTMENT_SUCCESS': {
            return {
                ...state,
                getAllotmentSuccess: true,
                getAllotmentData: action.payload?.data?.data?.data,
                getAllotmentCount:action.payload?.data?.data?.meta?.total,
                getAllotmentFailure: false,
            };
        }
        case 'GET_ALLOTMENT_FAILURE': {
            return {
                ...state,
                getAllotmentFailure: true,
                getAllotmentMetaMessage: action.payload?.data?.data?.meta?.message,
                getAllotmentSuccess: false,
            };
        }
        case 'RESET_GET_ALLOTMENT': {
            return {
                ...state,
                getAllotmentSuccess: false,
                getAllotmentFailure: false,
                getAllotmentData: [],
                getAllotmentMetaMessage: null,
            };
        }

        case 'CREATE_ALLOTMENT_SUCCESS': {
            return {
                ...state,
                createAllotmentSuccess: true,
                createAllotmentData: action.payload?.data?.data?.data,
                getAllotmentMetaMessage: action.payload?.data?.data?.meta?.message,
                createAllotmentFailure: false,
            };
        }
        case 'CREATE_ALLOTMENT_FAILURE': {
            return {
                ...state,
                createAllotmentFailure: true,
                getAllotmentMetaMessage: action.payload?.data?.data?.meta?.message,
                createAllotmentSuccess: false,
            };
        }
        case 'RESET_CREATE_ALLOTMENT': {
            return {
                ...state,
                createAllotmentSuccess: false,
                createAllotmentFailure: false,
                createAllotmentData: null,
                getAllotmentMetaMessage: null,
            };
        }

        case 'UPDATE_ALLOTMENT_SUCCESS': {
            return {
                ...state,
                updateAllotmentSuccess: true,
                updateAllotmentData: action.payload?.data?.data?.data,
                getAllotmentMetaMessage: action.payload?.data?.data?.meta?.message,
                updateAllotmentFailure: false,
            };
        }
        case 'UPDATE_ALLOTMENT_FAILURE': {
            return {
                ...state,
                updateAllotmentFailure: true,
                getAllotmentMetaMessage: action.payload?.data?.data?.meta?.message,
                updateAllotmentSuccess: false,
            };
        }
        case 'RESET_UPDATE_ALLOTMENT': {
            return {
                ...state,
                updateAllotmentSuccess: false,
                updateAllotmentFailure: false,
                updateAllotmentData: null,
                getAllotmentMetaMessage: null,
            };
        }

        case 'DELETE_ALLOTMENT_SUCCESS': {
            return {
                ...state,
                deleteAllotmentSuccess: true,
                getAllotmentMetaMessage: action.payload?.data?.data?.meta?.message,
                deleteAllotmentFailure: false,
            };
        }
        case 'DELETE_ALLOTMENT_FAILURE': {
            return {
                ...state,
                deleteAllotmentFailure: true,
                getAllotmentMetaMessage: action.payload?.data?.data?.meta?.message,
                deleteAllotmentSuccess: false,
            };
        }
        case 'RESET_DELETE_ALLOTMENT': {
            return {
                ...state,
                deleteAllotmentSuccess: false,
                deleteAllotmentFailure: false,
                getAllotmentMetaMessage: null,
            };
        }

        default: {
            return state;
        }
    }
}
